class LanguageSwitcher {
  constructor(buttonId, menuId) {
    this.lsButton = document.getElementById(buttonId);
    this.lsMenu = document.getElementById(menuId);
    this.lsMenuItems = this.lsMenu.querySelectorAll('[role="menuitem"]');
    this.currentFocusIndex = -1;

    this.lsButton.addEventListener("click", this.onButtonClick.bind(this));
    this.lsButton.addEventListener("keydown", this.onButtonKeyDown.bind(this));
    this.lsMenu.addEventListener("keydown", this.onMenuKeyDown.bind(this));
    document.addEventListener("click", this.onDocumentClick.bind(this));
    document.addEventListener("focusin", this.onDocumentFocusIn.bind(this));
    document.addEventListener("keydown", this.onDocumentKeyDown.bind(this));
  }

  toggle(open, { focusButton = false } = {}) {
    this.lsButton.setAttribute("aria-expanded", open);
    if (open) {
      this.lsMenu.removeAttribute("hidden");
      this.currentFocusIndex = -1;
    } else {
      this.lsMenu.setAttribute("hidden", "");
      if (focusButton) {
        this.lsButton.focus();
      }
    }
  }

  onButtonClick() {
    const isExpanded = this.lsButton.getAttribute("aria-expanded") === "true";
    this.toggle(!isExpanded);
  }

  onButtonKeyDown(e) {
    switch (e.key) {
      case "Enter":
      case " ":
      case "ArrowDown":
        e.preventDefault();
        this.toggle(true);
        if (this.lsMenuItems.length > 0) {
          this.currentFocusIndex = 0;
          this.lsMenuItems[0].focus();
        }
        break;
      case "ArrowUp":
        e.preventDefault();
        this.toggle(true);
        if (this.lsMenuItems.length > 0) {
          this.currentFocusIndex = this.lsMenuItems.length - 1;
          this.lsMenuItems[this.currentFocusIndex].focus();
        }
        break;
      case "Escape":
        this.toggle(false, { focusButton: true });
        break;
    }
  }

  onMenuKeyDown(e) {
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        this.currentFocusIndex =
          (this.currentFocusIndex + 1) % this.lsMenuItems.length;
        this.lsMenuItems[this.currentFocusIndex].focus();
        break;
      case "ArrowUp":
        e.preventDefault();
        this.currentFocusIndex =
          this.currentFocusIndex <= 0
            ? this.lsMenuItems.length - 1
            : this.currentFocusIndex - 1;
        this.lsMenuItems[this.currentFocusIndex].focus();
        break;
      case "Escape":
        e.preventDefault();
        this.toggle(false, { focusButton: true });
        break;
      case "Tab":
        this.toggle(false, { focusButton: true });
        break;
    }
  }

  onDocumentClick(e) {
    if (!this.lsButton.contains(e.target) && !this.lsMenu.contains(e.target)) {
      this.toggle(false, { focusButton: false });
    }
  }

  onDocumentFocusIn(e) {
    if (!this.lsButton.contains(e.target) && !this.lsMenu.contains(e.target)) {
      this.toggle(false, { focusButton: false });
    }
  }

  onDocumentKeyDown(e) {
    if (e.key === "Escape") {
      const isMenuOpen = this.lsButton.getAttribute("aria-expanded") === "true";
      if (isMenuOpen) {
        e.stopPropagation();
        this.toggle(false, { focusButton: true });
      }
    }
  }
}

function initLanguageSwitcher() {
  new LanguageSwitcher(
    "footer-language-selector-button",
    "footer-language-selector-menu"
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    initLanguageSwitcher();
  });
} else {
  initLanguageSwitcher();
}
